/**
 * Utility functions for handling bet amount preferences
 */

// Available bet amount options
const BET_OPTIONS = ["0.01", "0.02", "0.03", "0.05"];
const DEFAULT_BET_AMOUNT = "0.02";
const STORAGE_KEY = "deathx-bet-preference";

/**
 * Store bet preference in localStorage for later use
 * @param betAmount bet amount to store
 */
export const storeBetPreference = (betAmount: string): void => {
  try {
    // Validate that the bet amount is in the allowed options
    if (BET_OPTIONS.includes(betAmount)) {
      localStorage.setItem(STORAGE_KEY, betAmount);
    } else {
      console.warn("Invalid bet amount provided:", betAmount);
    }
  } catch (error) {
    console.error("Error storing bet preference:", error);
  }
};

/**
 * Get stored bet preference from localStorage
 * @returns stored bet amount or default value if not found/invalid
 */
export const getStoredBetPreference = (): string => {
  try {
    const storedBet = localStorage.getItem(STORAGE_KEY);
    
    // Return stored value if it's valid, otherwise return default
    if (storedBet && BET_OPTIONS.includes(storedBet)) {
      return storedBet;
    }
    
    return DEFAULT_BET_AMOUNT;
  } catch (error) {
    console.error("Error getting stored bet preference:", error);
    return DEFAULT_BET_AMOUNT;
  }
};

/**
 * Clear stored bet preference
 */
export const clearBetPreference = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error("Error clearing bet preference:", error);
  }
};

/**
 * Check if a bet amount is valid
 * @param betAmount bet amount to validate
 * @returns true if valid, false otherwise
 */
export const isValidBetAmount = (betAmount: string): boolean => {
  return BET_OPTIONS.includes(betAmount);
};

/**
 * Get all available bet options
 * @returns array of available bet amounts
 */
export const getBetOptions = (): string[] => {
  return [...BET_OPTIONS];
};